import * as net from 'util/Net';

/** Benchling credits are transferred in fixed increments. */
export const BOLTZ_CREDIT_INCREMENT = 1000;

/** Boltz API spend allocated per Benchling credit increment, in US dollars. */
export const BOLTZ_SPEND_PER_CREDIT_INCREMENT_USD = 80;

/** Maximum Benchling credits that can be transferred in a single deposit. */
export const BOLTZ_MAX_CREDITS_PER_TRANSFER = 5000;

export interface BoltzApiKeys {
  workspaceId: string;
  liveApiKey: string;
  testApiKey: string;
}

export interface BoltzApiSpendSummary {
  accruedSpend: number;
  spendLimit: number;
}

/**
 * Transfer Benchling credits to the Boltz API. The backend verifies the tenant has enough credits
 * (returning a 402 otherwise), increases the Boltz spending limit, and debits the credits.
 */
export async function transferBoltzCredits(creditAmount: number): Promise<void> {
  await net.postJSONPromise({
    url: '/1/api/model-hub/boltz-api/credit-transfer',
    data: {creditAmount},
  });
}

/** Provision live and test Boltz API keys. The keys are only returned once and cannot be retrieved again. */
export async function provisionBoltzApiKeys(): Promise<BoltzApiKeys> {
  return (await net.postJSONPromise({
    url: '/1/api/model-hub/boltz-api/api-keys',
    data: {},
  })) as BoltzApiKeys;
}

/** Fetch accrued Boltz API spend and its limit, in US dollars. */
export async function getBoltzApiSpendSummary(): Promise<BoltzApiSpendSummary> {
  return (await net.getJSONPromise('/1/api/model-hub/boltz-api/spending-limit')) as BoltzApiSpendSummary;
}
